module.exports = __webpack_public_path__ + "static/media/lazy_react.64fbbe16.jpg";